export const d_none =`
.d-none {
    display: none;
  }
`;
export const d_inline =`
.d-inline {
    display: inline;
  }
`;
export const d_inline_block =`
.d-inline-block {
    display: inline-block;
  }
`;
export const d_block =`
.d-block {
    display: block;
  }
`;
export const d_table =`
.d-table {
    display: table;
  }
`;
export const d_table_cell =`
.d-table-cell {
    display: table-cell;
  }
`;
export const d_table_row =`
.d-table-row {
    display: table-row;
  }
`;
export const d_flex =`
.d-flex {
    display: flex;
  }
`;
export const d_inline_flex =`
.d-inline-flex {
    display: inline-flex;
  }
`;
export const d_sm_none =`
@media (min-width: 576px){
  .d-sm-none {
    display: none !important;
  }
}
`;
export const d_sm_inline =`
@media (min-width: 576px){
  .d-sm-inline {
    display: inline !important;
  }
}
`;
export const d_sm_inline_block =`
@media (min-width: 576px){
  .d-sm-inline-block {
    display: inline-block !important;
  }
}
`;
export const d_sm_block =`
@media (min-width: 576px){
  .d-sm-block {
    display: block !important;
  }
}
`;
export const d_sm_table =`
@media (min-width: 576px){
  .d-sm-table {
    display: table !important;
  }
}
`;
export const d_sm_table_row =`
@media (min-width: 576px){
  .d-sm-table-row {
    display: table-row !important;
  }
}
`;
export const d_sm_table_cell =`
@media (min-width: 576px){
  .d-sm-table-cell {
    display: table-cell !important;
  }
}
`;
export const d_sm_flex =`
@media (min-width: 576px){
  .d-sm-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
}
`;
export const d_sm_inline_flex = `
@media (min-width: 576px){
  .d-sm-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}
`;
export const d_md_none = `
@media (min-width: 768px) {
    .d-md-none {
      display: none !important;
    }
}
`;
export const d_md_inline = `
@media (min-width: 768px) {
    .d-md-inline {
      display: inline !important;
    }
}
`;
export const d_md_inline_block = `
@media (min-width: 768px) {
    .d-md-inline-block {
      display: inline-block !important;
    }
}
`;
export const d_md_block = `
@media (min-width: 768px) {
    .d-md-block {
      display: block !important;
    }
}
`;
export const d_md_table = `
@media (min-width: 768px) {
    .d-md-table {
      display: table !important;
    }
}
`;
export const d_md_table_row = `
@media (min-width: 768px) {    
    .d-md-table-row {
      display: table-row !important;
    }
}
`;
export const d_md_table_cell = `
@media (min-width: 768px) {   
    .d-md-table-cell {
      display: table-cell !important;
    }
}
`;
export const d_md_flex = `
@media (min-width: 768px) {    
    .d-md-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
}
`;
export const d_md_inline_flex = `
@media (min-width: 768px) {
    .d-md-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
}
`;
export const d_lg_none = `
    @media (min-width: 992px) {
    .d-lg-none {
      display: none !important;
    }
}
`;
export const d_lg_inline = `
    @media (min-width: 992px) {
    .d-lg-inline {
      display: inline !important;
    }
}
`;
export const d_lg_inline_block = `
    @media (min-width: 992px) {
    .d-lg-inline-block {
      display: inline-block !important;
    }
}
`;
export const d_lg_block = `
    @media (min-width: 992px) {
    .d-lg-block {
      display: block !important;
    }
}
`;
export const d_lg_table = `
    @media (min-width: 992px) {
    .d-lg-table {
      display: table !important;
    }
}
`;
export const d_lg_table_row = `
    @media (min-width: 992px) {
    .d-lg-table-row {
      display: table-row !important;
    }
}
`;
export const d_lg_table_cell = `
    @media (min-width: 992px) {
    .d-lg-table-cell {
      display: table-cell !important;
    }
}
`;
export const d_lg_flex = `
    @media (min-width: 992px) {
    .d-lg-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
}
`;
export const d_lg_inline_flex = `
    @media (min-width: 992px) {
    .d-lg-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
}
`;
export const d_xl_none = `
@media (min-width: 1200px) {
    .d-xl-none {
      display: none !important;
    }
}
`;
export const d_xl_inline = `
@media (min-width: 1200px) {
    .d-xl-inline {
      display: inline !important;
    }
}
`;
export const d_xl_inline_block = `
@media (min-width: 1200px) {
    .d-xl-inline-block {
      display: inline-block !important;
    }
}
`;
export const d_xl_block = `
@media (min-width: 1200px) {
    .d-xl-block {
      display: block !important;
    }
}
`;
export const d_xl_table = `
@media (min-width: 1200px) {
    .d-xl-table {
      display: table !important;
    }
}
`;
export const d_xl_table_row = `
@media (min-width: 1200px) {
    .d-xl-table-row {
      display: table-row !important;
    }
}
`;
export const d_xl_table_cell = `
@media (min-width: 1200px) {
    .d-xl-table-cell {
      display: table-cell !important;
    }
}
`;
export const d_xl_flex = `
@media (min-width: 1200px) {
    .d-xl-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
}
`;
export const d_xl_inline_flex = `
@media (min-width: 1200px) {
    .d-xl-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
}
`;